var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.subscriber.isNoAds)?_c('div',{key:_vm.params,staticClass:"c-ad-intext-roll"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }